import { EventEmitter } from 'eventemitter3'

var POLONIEX_ENABLED = true

var POLO_TICKER = 'https://poloniex.com/public?command=returnTicker'
if (!POLONIEX_ENABLED) POLO_TICKER = '/api/ticker.json'

var LONG_POLL_INTERVAL = 5000

class RequestLimit {
  constructor(limit) {
    this.limit = limit // max # of requsts per second
    this.queue = []
    this.timer = null
  }

  processQueue() {
    var count = 0
    while (++count < this.limit) {
      var item = this.queue.shift()
      if (item) {
        item()
      } else {
        break
      }
    }
    
    if (this.queue.length === 0) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  perform(fn) {
    this.queue.push(fn)

    if (!this.timer) {
      this.processQueue()

      this.timer = setInterval(() => {
        this.processQueue()
      }, 1000)
    }
  }
}

class CoinStoreClass {
	constructor() {
		this.loaded = false
		this.emitter = new EventEmitter()
    this.limiter = new RequestLimit(5)

    // ticker indexed by currency pair name like BTC_ETH
		this.currencies = {}

    // which currency pairs have subscription
    this.topics = {}

    // UNUSED -- coin info indexed by coin symbol like XRP
    this.coins = {}

    if (localStorage.getItem('update_interval')) {
      LONG_POLL_INTERVAL = Number(localStorage.getItem('update_interval'))
    }
	}

  request(fn) {
    return new Promise((resolve, reject) => {
      this.limiter.perform(() => {
        resolve(fn())
      })
    })
  }

  // originSymbol: websocket gives the symbol that was updated
  dispatch(originSymbol) {
    this.emitter.emit('data', this)

    var date = new Date()

    if (originSymbol) {
      // NOTE: ticker price is under key `last`
      Object.keys(this.currencies).forEach(symbol => {
        if (symbol === originSymbol && this.topics[symbol]) {
          var close = Number(this.currencies[symbol].last)
          var data = {date, close}
          this.topics[symbol].emit('data', data)
        }
      })
      return
    }

    // NOTE: ticker price is under key `last`
    Object.keys(this.currencies).forEach(symbol => {
      if (this.topics[symbol]) {
        var close = Number(this.currencies[symbol].last)
        var data = {date, close}
        this.topics[symbol].emit('data', data)
      }
    })
  }

  subscribe(symbol, fn) {
    if (!this.topics[symbol]) {
      this.topics[symbol] = new EventEmitter()
    }

    this.topics[symbol].on('data', fn)
  }

  unsubscribe(symbol, handle) {
    if (!this.topics[symbol]) {
      return
    }

    this.topics[symbol].removeListener('data', handle)
  }

	removeListener(evt) {
    this.emitter.removeListener(evt)
  }

  on(evt, fun) {
    this.emitter.on(evt, fun)
  }

  setUpdateInterval(seconds) {
    LONG_POLL_INTERVAL = Number(seconds) * 1000
    localStorage.setItem('update_interval', LONG_POLL_INTERVAL + '')
  }

  getUpdateInterval() {
    return Math.round(LONG_POLL_INTERVAL / 1000)
  }

  longPollTicker() {
    if (this.pollTickerTimer) return

    this.pollTickerTimer = setInterval(() => {
      // barrier for slow network
      if (this.isPolling) return
      this.isPolling = true

      this.request(() => fetch(POLO_TICKER))
        .then(rep => rep.json())
        .then(json => {
          this.loadTicker(json)
          this.dispatch()
          this.isPolling = false
        })
        .catch(err => {
          console.log('Error getting Poloniex data')
          this.dispatch()
          this.isPolling = false
        })
    }, LONG_POLL_INTERVAL)
  }

	init() {
		if (this.loaded) return

    // load currency pairs then load coin info
    this.request(() => fetch(POLO_TICKER))
      .then(rep => rep.json())
      .then(json => {
        
        this.loadTicker(json)

        this.loaded = true
        this.emitter.emit('init', this)

        // poll ticker data
        this.longPollTicker()
      })
      .catch(err => {
        console.log('Error getting Poloniex data')
        // continue to init        
        this.loaded = true
        this.emitter.emit('init', this)
      })
	}

  loadCoins(json) {
    // for coin info loaded from
    // var POLO_CURRENCIES = 'https://poloniex.com/public?command=returnCurrencies'

    // filter out delisted coins
    var symbols = Object.keys(json);
    this.coins = symbols.reduce(function(acc, symbol) {
      var c = json[symbol]
      if (c.delisted) {
        return acc
      }

      c.symbol = symbol
      acc[symbol] = c
      return acc
    }, {})
  }

  loadTicker(json) {
    this.currencies = json
  }

  getCoin(symbol) {
    return this.coins[symbol]
  }

  getCurrencies() {
    return Object.keys(this.currencies)
  }
}

var CoinStore = new CoinStoreClass()

export { CoinStore, POLONIEX_ENABLED }



// WEBPACK FOOTER //
// ./src/stores/CoinStore.js